export function initFlexMedia() {
    document.addEventListener("click", (e) => {
        const trigger = e.target.closest("[data-modal-open]");
        if (!trigger) return;

        const modalId = trigger.dataset.modalOpen;
        const modal = document.getElementById(modalId);
        if (!modal) return;

        const embed = modal.querySelector(".flex-media__video-embed");
        if (!embed) return;

        const source = embed.getAttribute("data-video-source");

        // FILE: play the <video> element
        if (source === "file") {
            const video = embed.querySelector("video");
            if (video) {
                embed.classList.add("is-playing");
                video.setAttribute("controls", "controls");
                video.play().catch(() => {});
            }
            return;
        }

        // EMBED: inject autoplay iframe once
        const src = embed.getAttribute("data-src");
        if (!src || embed.querySelector("iframe")) return;

        const autoplaySrc = src + (src.includes("?") ? "&" : "?") + "autoplay=1";

        const iframe = document.createElement("iframe");
        iframe.src = autoplaySrc;
        iframe.loading = "lazy";
        iframe.frameBorder = "0";
        iframe.allow =
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        iframe.allowFullscreen = true;

        embed.classList.add("is-playing");
        embed.appendChild(iframe);
    });

    // Stop video when modal is closed
    document.addEventListener("click", (e) => {
        const isClose =
            e.target.closest(".c-modal__close") ||
            e.target.classList.contains("c-modal__overlay");

        if (!isClose) return;

        const modal = e.target.closest(".c-modal");
        if (!modal) return;

        const embed = modal.querySelector(".flex-media__video-embed");
        if (!embed) return;

        // Pause file video
        const video = embed.querySelector("video");
        if (video) {
            video.pause();
        }

        // Remove iframe so it stops streaming
        const iframe = embed.querySelector("iframe");
        if (iframe) {
            iframe.remove();
            embed.classList.remove("is-playing");
        }
    });

    // Stop on Escape key
    document.addEventListener("keydown", (e) => {
        if (e.key !== "Escape") return;

        const modal = document.querySelector(".c-modal.is-modal-open");
        if (!modal) return;

        const embed = modal.querySelector(".flex-media__video-embed");
        if (!embed) return;

        const video = embed.querySelector("video");
        if (video) video.pause();

        const iframe = embed.querySelector("iframe");
        if (iframe) {
            iframe.remove();
            embed.classList.remove("is-playing");
        }
    });
}
